import React, { useContext, useState } from "react";
import PropTypes from "prop-types";
import i18n from "~/assets/js/Helpers/i18n";
import { unpackAreaCookie } from "~/assets/js/Format";
import useAreaCookie from "~/assets/js/Helpers/hooks/useAreaCookie";
import { CheckoutContext } from "~/assets/js/pages/Checkout/CheckoutProvider";
import {
    updateLocation,
    dispatchLocationChange,
} from "~/assets/js/Api/storeApi";
import { AddToast } from "~/assets/js/components/Toast";
import AddressPopup from "../AddressPopup";
import useTriggerAddressPopupListener from "../../Helpers/hooks/useTriggerAddressPopupListener";

const BANNER_NOT_ON_PAGES = ["login", "register"];

const Banner = ({ forceHide = false }) => {
    const context = useContext(CheckoutContext);
    const hideBanner =
        context !== undefined &&
        BANNER_NOT_ON_PAGES.includes(context.state.page);
    const cookie = useAreaCookie();
    const deliveryAreaNotDefined = cookie?.area === undefined;
    const isJoiningGroupOrder = (() => {
        const currentUrl = window.location.pathname;
        const grpCartUrl = /group-cart\/([A-Za-z0-9]{8})\//;
        return currentUrl.match(grpCartUrl);
    })();

    const [overlayOpen, setOverlayOpen] = useState(
        deliveryAreaNotDefined && !isJoiningGroupOrder
    );

    const [forceOnGroupOrder, setForceOnGroupOrder] = useState(null);

    useTriggerAddressPopupListener(({ detail }) => {
        if ("deliveryType" in detail) {
            setForceOnGroupOrder(detail.deliveryType);
        }

        setOverlayOpen(true);
    });

    const submitData = async (
        area_update,
        location_update,
        address_update,
        shouldCloseOverlay = true
    ) => {
        const data = {
            area: area_update,
            location: location_update,
            address: address_update,
        };

        dispatchLocationChange(data);

        shouldCloseOverlay && setOverlayOpen(false);
        const success = await updateLocation();
        if (!success && context !== undefined) {
            return context.dispatch(
                AddToast("danger", i18n.t("toasts.locationUpdate.error"))
            );
        }
    };

    if (hideBanner) {
        return null;
    }

    return (
        <>
            {!forceHide && (
                <div id="banner" onClick={() => setOverlayOpen(true)}>
                    {deliveryAreaNotDefined ? (
                        <strong>{i18n.t("topbar.label.question")}</strong>
                    ) : (
                        <BannerContentSelected cookie={cookie} />
                    )}
                </div>
            )}
            {overlayOpen && (
                <AddressPopup
                    setOpen={setOverlayOpen}
                    submitData={submitData}
                    forceSelection={deliveryAreaNotDefined}
                    forceOnGroupOrder={forceOnGroupOrder}
                />
            )}
        </>
    );
};

const BannerContentSelected = ({ cookie }) => {
    const bannerContent = unpackAreaCookie(cookie);
    const { iconPath } = reactConfig;
    const bannerText = composeBannerText(bannerContent);
    const bannerImage = bannerContent.isDelivery ? (
        <img src={`${iconPath}/bicycle-new.svg`} alt="bicycle-icon" />
    ) : (
        <img src={`${iconPath}/shop-new.svg`} alt="shop-icon" />
    );

    return (
        <>
            {bannerImage}
            <span className="ph-no-capture">
                <strong>
                    {bannerContent.isDelivery
                        ? i18n.t("delivery.delivery")
                        : i18n.t("delivery.pickup")}
                </strong>
                {bannerText}
            </span>
        </>
    );
};

const composeBannerText = (orderType) => {
    const deliveryText = ` ${i18n.t("delivery.to")} ${orderType.location}`;
    const pickupText = ` ${i18n.t("delivery.in")} ${orderType.location}`;
    return orderType.isDelivery ? deliveryText : pickupText;
};

BannerContentSelected.propTypes = {
    cookie: PropTypes.object,
};

Banner.propTypes = {
    forceHide: PropTypes.bool,
};

export default Banner;
